import { render, staticRenderFns } from "./BalanceReport.vue?vue&type=template&id=55ffe5b2&scoped=true"
import script from "./BalanceReport.vue?vue&type=script&lang=js"
export * from "./BalanceReport.vue?vue&type=script&lang=js"
import style0 from "./BalanceReport.vue?vue&type=style&index=0&id=55ffe5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffe5b2",
  null
  
)

export default component.exports